import apiInstance from "./apiInstance";

const searchSurvey = () => {
  return apiInstance.post("/survey/list");
};

const surveyResult = (params) => {
  return apiInstance.post("/survey/result", params);
};

const getSurveyTags = () => {
  return apiInstance.post("/survey/tags");
};

const getStudentSurvey = (studentRoleId) => {
  return apiInstance.post(`/shareItem/student/search/survey/${studentRoleId}`);
};

const getStudentSurveyResult = (studentRoleId) => {
  return apiInstance.post(`/shareItem/student/search/survey/result/${studentRoleId}`);
};

const getStudentSurveyInfo = (studentRoleId) => {
  return apiInstance.post(`/shareItem/student/survey/info/${studentRoleId}`);
};

const getConservatorSurveyInfo = () => {
  return apiInstance.post(`/shareItem/conservator/survey`);
};

const getSurveyResultList = (surveyId) => {
  return apiInstance.get(`/survey/result/${surveyId}`);
};

const deleteSurveyResult = (resultId) => {
  return apiInstance.delete(`/survey/result/delete/${resultId}`);
};

const searchPersonnelSurvey = (resultId) => {
  return apiInstance.post(`/shareItem/personnel/search/survey`);
};

export {
  searchSurvey,
  surveyResult,
  getSurveyTags,
  getStudentSurvey,
  getStudentSurveyResult,
  getStudentSurveyInfo,
  getSurveyResultList,
  deleteSurveyResult,
  searchPersonnelSurvey,
  getConservatorSurveyInfo
};
